// 请求重试仅使用本地状态，不生成或发送额外请求头。
const retryAdapters = new WeakSet();

function isAppRequest(config, bases) {
    try {
        const location = window.location.href;
        let address = config.url || '';
        if (config.baseURL && !/^(?:[a-z][a-z\d+.-]*:)?\/\//i.test(address)) {
            address = config.baseURL.replace(/\/+$/, '') + '/' + address.replace(/^\/+/, '');
        }
        const url = new URL(address, location);
        return [bases.apiUrl, bases.uploadUrl, bases.previewApiwUrl,
            bases.sharePageApiUrl && bases.sharePageApiUrl.replace(/\/+$/, '') + '/api',
            bases.liteUrl && bases.liteUrl.replace(/\/+$/, '') + '/lite']
            .filter(Boolean).some(base => {
                const api = new URL(base, location);
                const path = api.pathname.replace(/\/+$/, '');
                return url.origin === api.origin && (url.pathname === path || url.pathname.indexOf(path + '/') === 0);
            });
    } catch (ignored) {
        return false;
    }
}

export default function retryRequest(axios, error, bases) {
    const config = error.config;
    if (!config || axios.isCancel(error) || retryAdapters.has(config.adapter)) return Promise.reject(error);
    const limit = config.retry === undefined ? (isAppRequest(config, bases) ? axios.defaults.retry : 0) : config.retry;
    const adapter = config.adapter || axios.defaults.adapter;
    if (!limit || typeof adapter !== 'function') return Promise.reject(error);

    // Axios 0.19 会丢弃自定义计数属性；已知的 adapter 函数可以保留本次重试链的身份。
    // 内层请求的错误直接回到下面的有界循环，避免响应拦截器再次创建重试链。
    const retryAdapter = request => adapter(request);
    retryAdapters.add(retryAdapter);
    const retryConfig = Object.assign({}, config, { adapter: retryAdapter });
    const delay = config.retryDelay === undefined ? axios.defaults.retryDelay : config.retryDelay;
    let count = 0;
    function attempt(lastError) {
        if (axios.isCancel(lastError) || count >= limit) return Promise.reject(lastError);
        count++;
        return new Promise(resolve => setTimeout(resolve, delay || 1))
            .then(() => axios(retryConfig)).catch(attempt);
    }
    return attempt(error);
}



// WEBPACK FOOTER //
// ./src/js/request_retry.js